<template>
  <v-dialog width="80%" persistent v-model="isShow">
    <v-card min-height="250">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close">mdi-close</v-icon>
      </v-toolbar>
      <!--<v-tabs v-model="tab">
        <v-tab>Information</v-tab>
        <v-tab :disabled="calendar.identity == ''">Dates</v-tab>
      </v-tabs>-->

      <div v-if="tab == 0" style="min-height:200px" >
        <v-row style="width: 95%" class="ml-5 mt-5">
          <v-col
            cols="12"
            lg="5"
            md="5"
            sm="5"
            style="padding: 0px"
            class="mr-5"
          >
            <v-text-field
              label="Calendar Name"
              v-model="calendar.name"
              style="padding: 0px"
            ></v-text-field>
          </v-col>

          <v-col cols="12" lg="5" md="5" sm="5" style="padding: 0px">
            <v-text-field
              label="Calendar Description"
              v-model="calendar.description"
              style="padding: 0px"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row style="width: 95%" class="ml-5 mt-5">
          <!--    <v-col cols="12" lg="5" md="5" sm="5" style="padding: 0px" class="mr-5">
            <v-text-field
              label="Owner"
              v-model="calendar.owner"
              style="padding: 0px"
            ></v-text-field>
          </v-col>-->
          <v-col cols="12" lg="5" md="5" sm="5" style="padding: 0px">
            <!--     <v-autocomplete
              label="Management Groups"
              :items="groups"
              v-model="calendar.managementPermissionIdentities"
              style="padding: 0px"
              return-object
              multiple
              item-text="name"
            ></v-autocomplete> -->
            <v-text-field
              label="Management Person"
              v-model="mgtIds"
              hint="000001;000002;000003"
              v-if="userProfile.isAdmin"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="4"
            sm="4"
            style="padding: 0px"
            
          >
            <v-autocomplete
              prepend-icon="mdi-database-search"
              label="Person Selector (type name or id to search)"
              v-model="mgtIdSelector"
              :items="items"
              :loading="isLoading"
              :search-input.sync="searchStaff"
              item-text="name"
              item-value="hostKey"
              v-if="userProfile.isAdmin"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row style="width: 95%" class="ml-5 mt-5">
          <v-spacer></v-spacer>
          <v-btn outlined @click="save">Save</v-btn>
        </v-row>
      </div>

      <div v-if="tab == 0 && this.calendar.identity">
        <v-dialog width="600" persistent v-model="showEditor">
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>NEW EVENT</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon @click="showEditor = false">mdi-close</v-icon>
          </v-toolbar>
          <v-card class="pt-8 pl-2">
            <v-card-text>
              <v-row style="width: 95%">
                <v-col cols="12" lg="12" md="12" sm="12" style="padding: 0px">
                  <v-text-field
                    label="Name"
                    v-model="currentEvent.name"
                    style="padding: 0px"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row style="width: 95%">
                <v-col cols="12" lg="12" md="12" sm="12" style="padding: 0px">
                  <v-text-field
                    label="Note"
                    v-model="currentEvent.description"
                    style="padding: 0px"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row style="width: 95%">
                <v-col
                  cols="12"
                  lg="5"
                  md="5"
                  sm="5"
                  style="padding: 0px"
                  class="mr-5"
                >
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="currentEvent.startDateTime"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="currentEvent.startDateTime"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" lg="5" md="5" sm="5" style="padding: 0px">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="currentEvent.endDateTime"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="currentEvent.endDateTime"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-row style="width: 95%">
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  color="green"
                  small
                  class="mr-3"
                  @click="add"
                  v-if="!currentEvent.identity"
                  >Create</v-btn
                >
                <v-btn
                  outlined
                  color="green"
                  small
                  class="mr-3"
                  @click="update"
                  v-if="currentEvent.identity"
                  >Update</v-btn
                >
                <v-btn outlined color="error" small @click="clear">Clear</v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-data-table
          :items="calendar.events"
          class="mt-3"
          :headers="hearders"
          :loading="isTableLoading"
          :search="search"
          dense
        >
          <template v-slot:top>
            <v-btn
              class="d-flex justify-start ml-3"
              small
              color="primary"
              @click="showEditor = true"
              >Create Event</v-btn
            >
            <v-toolbar flat>
              <v-toolbar-title>Events</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-text-field
                class="mt-5"
                label="SEARCH"
                v-model="search"
                style="width: 80px"
                v-show="isSearchable"
              ></v-text-field>
              <!-- <v-btn @click="showEditor = true" color="secondary" small>CREATE</v-btn>-->
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon @click="editItem(item)" class="mr-2">mdi-pencil</v-icon>
            <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
          </template>

          <template v-slot:footer> </template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { calService } from "@/api/cal-service";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "CalendarEditor",
  props: { isShow: Boolean, calendar: Object },
  computed: {
    ...mapGetters(["userProfile", "groupList"]),
  },
  data: () => {
    return {
      title: "Create",
      tab: 0,
      showEditor: false,
      isSearchable: true,
      isLoading: false,
      currentEvent: {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      },
      mgtIds: "",
      mgtIdSelector: "",
      searchStaff: "",
      items: [],
      hearders: [
        { text: "Name", value: "name", width: "15%", sortable:false },
        { text: "Note", value: "description", width: "25%", sortable:false },

        { text: "Start", value: "startDateTime", width: "10%", sortable:false },
        { text: "End", value: "endDateTime", width: "10%", sortable:false },
        { text: "Actions", value: "actions", width: "5%", sortable:false },
      ],
      groups: [
        //{ identity: "ASO", name: "ASO" },
        //{ identity: "HR", name: "HR" },
      ],
      menu1: false,
      menu2: false,
      isTableLoading: false,
      search: "",
    };
  },
  async mounted() {
    if (!this.userProfile) await this.$store.dispatch("getUserProfile");
    //console.log(this.userProfile)
    if (!this.userProfile.isAdmin) {
      this.groups = [];
      this.userProfile.groups.forEach((g) => {
        this.groups.push({ identity: g, name: g });
      });
    } else {
      if (!this.groupList || this.groupList.length == 0)
        await this.$store.dispatch("getGroupList");
      this.groups = this.groupList;
    }
    console.log(this.groups);
    //this.title = 'Edit ' + this.calendar.name
  },
  methods: {
    close() {
      //this.calendar = {};
      this.tab = 0;
      this.isSearchable = true;
      this.mgtIds = '';
      this.currentEvent = {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      };
      this.$emit("close", "close");
    },
    async save() {
      if (!this.calendar.name || this.calendar.name == "")
      {
        alert('Please give this calendar a name')
        return;
      }
      if (!this.mgtIds || this.mgtIds.length == 0) {
        this.mgtIds = this.userProfile.hostKey
        //alert("Please enter management person's ID");
        //return;
      }

      this.calendar.managementPermissionIdentities = this.mgtIds.split(";");

      if (!this.calendar.identity) {
        this.calendar.identity = this.guid();
        this.isSearchable = false;
      }
      this.calendar.events.forEach((e) => {
        e.endDateTime = moment(e.endDateTime)
                        //.add(1, "days").add(-1, "seconds");
      });

      await calService.updateCal(this.calendar);

      this.calendar.events.forEach((e) => {
        e.endDateTime = moment(e.endDateTime).format("yyyy-MM-DD");
      });
      //this.close();
    },
    clear() {
      this.currentEvent = {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      };
    },
    async add() {
     if (!this.mgtIds) {
        this.mgtIds = this.userProfile.hostKey
        //alert("Please enter management person's ID");
        //return;
      }
      this.calendar.managementPermissionIdentities = this.mgtIds.split(";");

      this.currentEvent.identity = this.guid();

      this.calendar.events.push(this.currentEvent);
      let _pattern = this.calendar.events;
      _pattern.sort(
        (a, b) =>
          moment(a.startDateTime).valueOf() - moment(b.startDateTime).valueOf()
      );

      this.isTableLoading = true;
      this.currentEvent.endDateTime = moment(this.currentEvent.endDateTime)
      //  .add(1, "day")
      //  .add(-1, "second");

      await calService.updateCal(this.calendar);

      this.currentEvent.endDateTime = moment(
        this.currentEvent.endDateTime
      ).format("yyyy-MM-DD");
      this.isTableLoading = false;
      this.currentEvent = {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      };
    },
    editItem(item) {
      this.showEditor = true;
      this.currentEvent = item;
    },
    async deleteItem(item) {
      let idx = this.calendar.events.findIndex(
        (x) => x.identity == item.identity
      );
      if (idx != -1) this.calendar.events.splice(idx, 1);
      await calService.updateCal(this.calendar);
    },
    async update() {
      if (!this.mgtIds) {
        this.mgtIds = this.userProfile.hostKey
        //alert("Please enter management person's ID");
        //return;
      }

      this.calendar.managementPermissionIdentities = this.mgtIds.split(";");

      let idx = this.calendar.events.findIndex(
        (x) => x.identity == this.currentEvent.identity
      );
      if (idx != -1) this.calendar.events.splice(idx, 1);

      this.calendar.events.push(this.currentEvent);

      let _pattern = this.calendar.events;
      _pattern.sort(
        (a, b) =>
          moment(a.startDateTime).valueOf() - moment(b.startDateTime).valueOf()
      );

      this.isTableLoading = true;
      this.currentEvent.endDateTime = moment(this.currentEvent.endDateTime)
        .add(1, "day")
        .add(-1, "second");
      await calService.updateCal(this.calendar);

      this.currentEvent.endDateTime = moment(
        this.currentEvent.endDateTime
      ).format("yyyy-MM-DD");
      this.isTableLoading = false;

      //console.log("updated");
      this.currentEvent = {
        identity: "",
        name: "",
        startDateTime: "",
        endDateTime: "",
      };
    },
    guid() {
      var d = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
        }
      );
      return uuid;
    },
  },
  watch: {
    calendar: {
      handler() {
        if (this.calendar.identity) {
          this.title = "Edit " + this.calendar.name;
          this.mgtIds = this.calendar.managementPermissionIdentities.join(";");
        } else this.title = "Create";
        //this.tab = 0
      },
      deep: true,
    },
    searchStaff(val) {
      if (!val || val.indexOf(" - ") != -1) return;

      if (this.isLoading) return;

      this.isLoading = true;

      const url = process.env.VUE_APP_HOST;

      let auth = localStorage.getItem("scientia-session-authorization");

      let access_token = JSON.parse(auth).access_token;

      let headers = {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      };
      // Lazily load input items
      fetch(
        url +
          "api/Foundation/Staff?page=1&itemsPerPage=10&asc=true&searchItem=" +
          val,
        headers
      )
        .then((res) => res.json())
        .then((res) => {
          const { count, result } = res;
          this.count = count;
          this.items = result;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    mgtIdSelector(val) {
      if (val) this.mgtIds = this.mgtIds + ";" + val;
    },
  },
};
</script>

<style>
.v-dialog > .v-card > .v-toolbar {
  position: sticky;
  top: 0;
  z-index: 999;
}
</style>